import * as React from "react";

function SvgPlainFilter(props) {
  return <svg fill="none" width={18} height={18} viewBox="0 0 18 18" {...props}><path fill="#fff" d="M9 18A9 9 0 109 0a9 9 0 000 18z" /><path stroke="currentColor" d="M14 6.5H4M12 9.5H6M10 12.5H8" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/plain-filter_9817da.svg";
export { SvgPlainFilter as ReactComponent };